import { Pipe, PipeTransform } from '@angular/core';
import { GridColumn, GridItem } from '../grid-control.model';

@Pipe({
  name: 'filterMobile',
  pure: false
})
export class FilterMobilePipe implements PipeTransform {
  transform(columns: GridColumn[], item: GridItem): GridColumn[] {
    // Những giá trị undefined, null và rỗng sẽ bỏ qua khi hiển thị trên mobile
    return columns.filter(column => (item[column.field] !== undefined
      && item[column.field] !== null
      && item[column.field] !== '')
      || column.htmlTemplate
      || column.type === 'children'
      || (column.type === 'string' && column.commands?.length > 0));
  }
}
